import apiClient from "@/api/client";

export interface EmployeeComment {
  id: string;
  employee: string;
  author: string | null;
  author_name: string;
  author_role: string;
  author_is_ceo: boolean;
  author_profile_picture_url: string | null;
  content: string;
  created_at: string;
}

const wrap = <T>(res: { data: { data: T } }) => res.data.data;

export const employeeCommentsApi = {
  list: (employeeId: string) =>
    apiClient
      .get<{ data: EmployeeComment[] }>(`/auth/employee-comments/?employee=${employeeId}`)
      .then(wrap),

  create: (employeeId: string, content: string, mentionIds?: string[]) =>
    apiClient
      .post<{ data: EmployeeComment }>("/auth/employee-comments/", {
        employee: employeeId,
        content,
        mention_ids: mentionIds ?? [],
      })
      .then(wrap),

  delete: (id: string) =>
    apiClient.delete(`/auth/employee-comments/${id}/`),
};
